interface Props {
  proxyURL: string;
  appPath?: string;
  appSearchParams?: Record<string, unknown>;
}

export function parseProxyURL({ proxyURL, appPath, appSearchParams }: Props) {
  const parsedAppPath = parseAppPath(appPath);
  let parsedProxyURL = proxyURL + parsedAppPath;

  if (!appSearchParams) return parsedProxyURL;

  const tempAppSearchParams = Object.entries(appSearchParams).map(
    ([k, v]) => `${k}=${parseSearchParamValue(v)}`
  );
  const stringifiedAppSearchParams =
    tempAppSearchParams.length > 0 ? `?${tempAppSearchParams.join("&")}` : "";

  return parsedProxyURL + stringifiedAppSearchParams;
}

function parseAppPath(appPath: string | undefined) {
  if (!appPath) return "";
  if (appPath[0] !== "/") return `/${appPath}`;
  return appPath;
}

function parseSearchParamValue(value: unknown) {
  if (typeof value === "string") return encodeURIComponent(value);
  return value;
}
